import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { User, UserFilters, UserSort } from '../../lib/types/models/users/user'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getUsers(input: PaginationRequest<UserFilters, string, Version, UserSort> = {}) {
  if (!input.sort) input.sort = { firstName: 'asc' }
  return restApiClient
    .url(encodeNestedObject<PaginationRequest>(constructApiUrl(API.user.getAll.url, null), input))
    .get<PaginationResponse<User>>()
}
